
















import Vue from 'vue'
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class Privacy extends BasicComponent {

  created() {

  }

  mounted() {
    this.trackPage("Datenschutz");
  }

}

